import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { RulesTurnsService } from 'src/app/services/turns-services/rules-turns-service/rules-turns.service';
import { tap, flatMap } from 'rxjs/operators';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-turns-rules-rule',
  templateUrl: './turns-rules-rule.component.html',
  styleUrls: ['./turns-rules-rule.component.scss']
})
export class TurnsRulesRuleComponent implements OnInit, OnChanges {

  @Input() rule;
  @Input() operators;
  @Input() actions;
  @Input() desks;
  editing: boolean;
  ruleForm = new FormGroup({
    selectedDesk: new FormControl(null, Validators.required),
    ruleOperator: new FormControl(null, Validators.required),
    ruleValue: new FormControl(null, Validators.required),
    ruleAction: new FormControl(null, Validators.required)
  });

  ngOnChanges() {
    this._resetForm(this.rule);
  }

  constructor(private ruleTurnsService: RulesTurnsService,
              private snackBarService: SnackBarService) { }

  ngOnInit() {
  }

  private _resetForm(rule) {
    this.ruleForm.patchValue({
      selectedDesk: this.setSelectedDesk(),
      ruleOperator: this.setRuleOperator(),
      ruleAction: this.setRuleAction(),
      ruleValue: rule.RuleValue
    });
  }

  public edit() {
    this.editing = true;
    this._resetForm(this.rule);
  }

  public cancel() {
    this.editing = false;
  }

  public updateRule() {
    const validation = this.validateForm();
    if (validation === true) {
      this.ruleTurnsService.updateRule(this.rule, this.ruleForm).pipe(
        tap(o => this.ruleTurnsService.refreshRules()),
      ).subscribe();
    } else {
      this.snackBarService.open(validation, 'error');
    }
  }

  private validateForm() {
    if (!this.ruleForm.get('selectedDesk').valid) {
      return 'turns-page.snackbar messages.selected desk error';
    } else if (!this.ruleForm.get('ruleAction').valid) {
      return 'turns-page.snackbar messages.rule action error';
    } else if (!this.ruleForm.get('ruleOperator').valid) {
      return 'turns-page.snackbar messages.rule operator error';
    } else if (!this.ruleForm.get('ruleValue').valid) {
      return 'turns-page.snackbar messages.rule value error';
    } else {
      return true;
    }
  }

  public deleteRule() {
    this.ruleTurnsService.deleteRule(this.rule.InternalId).pipe(
      tap(o => this.ruleTurnsService.refreshRules())
    ).subscribe();
  }

  public getOperatorValue(operatorId) {
    if (this.operators && operatorId) {
      return this.operators.find(o => o.InternalId === operatorId).Value;
    }
    return null;
  }

  public getActionValue(actionId) {
    if (this.actions && actionId) {
      return this.actions.find(a => a === actionId);
    }
    return null;
  }

  public getDeskName(turnDeskInternalId) {
    if (this.desks && turnDeskInternalId) {
      if (this.desks.find(d => d.InternalId === turnDeskInternalId)) {
        return this.desks.find(d => d.InternalId === turnDeskInternalId).DeskName;
      }
    }
    return null;
  }

  public setSelectedDesk() {
    if (this.rule && this.desks && (this.desks.length > 0)) {
      for (const desk of this.desks) {
        if (desk.InternalId === this.rule.TurnDeskInternalId) {
          return desk;
        }
      }
    } else {
      return null;
    }
  }

  public setRuleOperator() {
    if (this.rule && this.operators && (this.operators.length > 0)) {
      for (const operator of this.operators) {
        if (operator.InternalId === this.rule.RuleOperator) {
          return operator;
        }
      }
    } else {
      return null;
    }
  }

  public setRuleAction() {
    if (this.rule && this.actions && (this.actions.length > 0)) {
      for (const action of this.actions) {
        if (action === this.rule.RuleAction) {
          return action;
        }
      }
    } else {
      return null;
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }
}
